import React from "react";
import styled, { css } from "styled-components";

import LogoIcon from "../Icons/LogoIcon";
import ResponsiveContainer from "../ResponsiveContainer";

export type LogoProps = {
  altText?: string;
  logoUrl?: string;
  isOnDarkBackground?: boolean;
};

const StyledLogo = styled(LogoIcon)<{ isOnDarkBackground: boolean }>`
  width: 210px;
  height: 24px;
  ${(props) =>
    props.isOnDarkBackground === true
      ? css`
          color: ${props.theme.palette.white};
        `
      : css`
          color: ${props.theme.palette.brand.main};
        `}
`;

const Logo: React.FC<React.PropsWithChildren<LogoProps>> = ({
  altText = "Finanzchef24 GmbH Gewerbe einfach gut versichert",
  logoUrl,
  isOnDarkBackground = false,
  ...props
}) => {
  if (logoUrl) {
    return (
      <React.Fragment>
        <ResponsiveContainer showOn={["mobile"]}>
          <img src={logoUrl} alt={altText} height="40px" />
        </ResponsiveContainer>
        <ResponsiveContainer showOn={["tablet", "desktop"]}>
          <img src={logoUrl} alt={altText} height="45px" />
        </ResponsiveContainer>
      </React.Fragment>
    );
  }
  return <StyledLogo isOnDarkBackground={isOnDarkBackground} {...props} />;
};

export default Logo;
